import './style.css';

function Photos() {
    return (
        <div id="photos">
            <div id="invitation-container">
                <div className="invitation-content"><h1 id="PHOTOS">PHOTOS</h1></div>
                <br/>
                <div className="invitation-content photos-message">
                    Bienvenue sur cette rubrique pour se replonger avec joie dans les chouettes activités partagées ensemble.
                </div>
                <br/>
                <div className="invitation-content photos-link">
                    <h1><a href="https://drive.google.com/drive/folders/1nYvpD2FJu852iAINSqWgq7AblV3eeDnV?usp=sharing" target="_blank" rel="noopener noreferrer">Lien vers les photos ICI</a></h1>
                </div>
                <br/>
                <div className="invitation-content">
                    <p id="description" style={{ fontSize: '16px', color: '#ffa7a7', fontStyle: 'italic', lineHeight: '1.5' }}>
                        Pour rappel, aucune photo ne peut être utilisée ou publiée sur les réseaux sociaux, dans la presse ou sur internet sans l’accord préalable des parents concernés et du comité.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Photos;